import { reportAppWarning } from "../utils/reportAppError";

export const sendUserTyping = async () => {
  try {
    Genesys("command", "MessagingService.sendTyping", {
      isTyping: true,
    });
  } catch (error) {
    reportAppWarning({ scope: "sendUserTyping", error });
  }
};
